export default __webpack_public_path__ + "static/media/Travis.af0d4ac4.jpeg";